// src/components/Documentation/components/Sidebar.jsx
export default function Sidebar({ mobileMenuOpen, setMobileMenuOpen }) {
  const handleLinkClick = () => {
    // Close mobile menu when a link is clicked
    setMobileMenuOpen(false);
  };

  return (
    <>
      {/* Backdrop Overlay for Mobile */}
      {mobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity"
          onClick={() => setMobileMenuOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar Navigation */}
      <nav
        className={`
          w-64 bg-gray-50 border-r border-gray-200 overflow-y-auto
          lg:sticky lg:top-16 lg:h-[calc(100vh-4rem)] lg:z-10
          fixed inset-y-0 left-0 z-50 transform transition-transform duration-300 ease-in-out
          ${mobileMenuOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}
        `}
      >
        {/* Mobile Close Button */}
        <div className="lg:hidden flex justify-end p-4 border-b border-gray-200">
          <button
            onClick={() => setMobileMenuOpen(false)}
            className="p-2 rounded-lg text-gray-600 hover:bg-gray-200"
            aria-label="Close navigation menu"
          >
            <svg
              className="w-6 h-6"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        {/* Navigation Content */}
        <div className="p-6">
          <div className="space-y-6">
            {/* Getting Started */}
            <div>
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
                Getting Started
              </div>
              <a
                href="#introduction"
                onClick={handleLinkClick}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-2 px-3 rounded transition-colors"
              >
                Introduction
              </a>
              <a
                href="#authentication"
                onClick={handleLinkClick}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-2 px-3 rounded transition-colors"
              >
                Authentication
              </a>
            </div>

            {/* Screenshots */}
            <div>
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
                Screenshots
              </div>
              <a
                href="#screenshot"
                onClick={handleLinkClick}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-2 px-3 rounded transition-colors"
              >
                POST /screenshot
              </a>
              <a
                href="#batch"
                onClick={handleLinkClick}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-2 px-3 rounded transition-colors"
              >
                POST /screenshot/batch
                <span className="ml-1 text-xs bg-blue-100 text-blue-700 px-1.5 py-0.5 rounded">Pro</span>
              </a>
              <a
                href="#parameters"
                onClick={handleLinkClick}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-2 px-3 rounded transition-colors"
              >
                Parameters
              </a>
              <a
                href="#features"
                onClick={handleLinkClick}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-2 px-3 rounded transition-colors"
              >
                Advanced Features
              </a>
            </div>

            {/* Device Emulation */}
            <div>
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
                Device Emulation
              </div>
              <a
                href="#device"
                onClick={handleLinkClick}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-2 px-3 rounded transition-colors"
              >
                POST /screenshot/device
              </a>
            </div>

            {/* PDF Generation */}
            <div>
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
                PDF Generation
              </div>
              <a
                href="#pdf"
                onClick={handleLinkClick}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-2 px-3 rounded transition-colors"
              >
                POST /pdf
              </a>
            </div>

            {/* Reference */}
            <div>
              <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
                Reference
              </div>
              <a
                href="#errors"
                onClick={handleLinkClick}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-2 px-3 rounded transition-colors"
              >
                Error Codes
              </a>
              <a
                href="#ratelimits"
                onClick={handleLinkClick}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 py-2 px-3 rounded transition-colors"
              >
                Rate Limits
              </a>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}